/**
 * 製品構成品リビジョン エンティティ
 */
import { isNud } from '@/utilities/typing';
import ProductRevision from '@/models/entities/product-revision';
import ProductComponent from '@/models/entities/product-component';
import Product from '@/models/entities/product';

class ProductComponentRevision {
    product_component_revision_id;
    product_revision;
    product_component;
    child_product;
    sequence;
    component_count;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.product_component_revision_id = properties.product_component_revision_id ?? null;
        this.product_revision = new ProductRevision(properties.product_revision);
        this.product_component = new ProductComponent(properties.product_component);
        this.child_product = new Product(properties.child_product);
        this.sequence = properties.sequence ?? null;
        this.component_count = properties.component_count ?? null;
    }

    get component_count_display() {
        if (this.component_count) {
            return parseInt(this.component_count, 10).toLocaleString();
        }

        return this.component_count;
    }
}

export default ProductComponentRevision;
